export default __webpack_public_path__ + "static/media/Encrypted_Files.2d72cdd9.png";